<template>
  <!-- <div> -->
  <a :href="sideBarItem.RouterName !== '' ? sideBarItem.RouterName : '#'" class="nav-link" @click="toggle" style="cursor: pointer;">
    <i :class="sideBarItem.Icon"></i>
    <span>
      {{ $t(sideBarItem.DisplayNameLocalizationCode) }}
      <span class="d-block fw-normal opacity-50">
        {{ $t(sideBarItem.DescriptionLocalizationCode) }}
      </span>
    </span>
  </a>

  <ul :class="{ 'nav-group-sub': true, 'collapse': !isExpanded }">
    <li v-for="(subItem, subItemIndex) in sideBarItem.SubItems" :key="subItemIndex" class="nav-item" @click="closeSidebarForMobile">
      <!-- <SideBarSubItemComp :sideBarSubItem="subItem"></SideBarSubItemComp> -->
      <SideBarSubItemComp v-if="permissionService.hasPermissionForSubItems(subItem)" :sideBarSubItem="subItem"></SideBarSubItemComp>
    </li>
  </ul>
  <!-- </div> -->
</template>

<script>
import { useScreenSize, ScreenSize } from '@/composables/useScreenSize';
import SideBarSubItemComp from "@/components/layoutComponents/SideBar/SideBarSubItemComp";
import { SideBarItemModel } from "@/models/sideBarModel/sideBarModel.js";
import { useAuthAppStore } from "@/store/stores/authStore";

export default {
  props: {
    sideBarItem: {
      type: Object,
      default: null
    },
  },
  inject: ["permissionService"],
  data() {
    return {
      isExpanded: false,
      useAuthAppStore: useAuthAppStore(),
      currentScreenSize: useScreenSize().currentScreenSize
    };
  },
  methods: {
    toggle() {

      this.isExpanded = this.sideBarItem.isExpanded;
    },
    closeSidebarForMobile(){
      if (this.currentScreenSize === ScreenSize.MOBILE) {
        document.querySelector(".sidebar-mobile-expanded").classList.remove('sidebar-mobile-expanded');
      }
    },
    hasPermissionForSubItems(subItem) {
      // console.log("hasPermissionForSubItems subItem", subItem);
      let userPerms = this.useAuthAppStore?.getParsedToken?.perms;
      if (!userPerms) return false;

      // Eğer PermissionCode tanımlıysa kontrol et
      if (subItem.PermissionCode) {
        return userPerms.includes(subItem.PermissionCode);
      }

      // Eğer PermissionCodes tanımlıysa en az bir yetkinin eşleşip eşleşmediğini kontrol et
      if (subItem.PermissionCodes && subItem.PermissionCodes.length > 0) {
        return subItem.PermissionCodes.some(code => userPerms.includes(code));
      }

      // Eğer yetki tanımlı değilse true döndür (yetki kontrolü yapılmıyorsa göster)
      return true;

    }
  },
  components: {
    SideBarSubItemComp,
  },
};
</script>

<style scoped>
/* İhtiyaçlarınıza göre ek CSS yazabilirsiniz */
</style>
